import React, { useEffect, useState } from "react";
import axios from "axios";
import { Plus, Trash2 } from "lucide-react";
import { PageHeader, EmptyState } from "../components/Brand";
import { useApp, API } from "../AppContext";

export default function Clients() {
  const { t, lang } = useApp();
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "", address: "" });
  const [open, setOpen] = useState(false);

  const load = () => axios.get(`${API}/clients`).then(({ data }) => setClients(data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name) return;
    await axios.post(`${API}/clients`, form);
    setForm({ name: "", company: "", email: "", phone: "", address: "" });
    setOpen(false);
    load();
  };

  const remove = async (id) => { await axios.delete(`${API}/clients/${id}`); load(); };

  return (
    <div>
      <PageHeader title={t.clients_p.title}
        action={<button className="btn-red" onClick={() => setOpen(true)} data-testid="new-client-btn"><Plus size={16} /> {t.clients_p.new}</button>} />

      {open && (
        <div className="glass-strong p-6 mb-6">
          <h3 className="font-heading text-lg font-semibold mb-4" style={{ color: "#D4AF37" }}>{t.clients_p.new}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input className="input-dark" placeholder={t.clients_p.name + " *"} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="client-form-name" />
            <input className="input-dark" placeholder={t.clients_p.company} value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
            <input className="input-dark" placeholder={t.clients_p.email} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input className="input-dark" placeholder={t.clients_p.phone} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
            <input className="input-dark md:col-span-2" placeholder={t.clients_p.address} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button className="btn-ghost text-sm" onClick={() => setOpen(false)}>{lang === "fr" ? "Annuler" : "Cancel"}</button>
            <button className="btn-red text-sm" onClick={save} data-testid="client-save">{t.clients_p.save}</button>
          </div>
        </div>
      )}

      {clients.length === 0 ? (
        <EmptyState title={t.clients_p.empty} icon={<Plus size={24} color="#D4AF37" />} />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {clients.map((c) => (
            <div key={c.id} className="glass-card p-5 group">
              <div className="flex items-start justify-between mb-2">
                <h3 className="font-heading text-lg font-semibold" style={{ color: "#F5F5F5" }}>{c.name}</h3>
                <button onClick={() => remove(c.id)} className="opacity-0 group-hover:opacity-100 transition p-1.5 rounded-full hover:bg-red-500/10" data-testid={`del-client-${c.id}`}>
                  <Trash2 size={14} color="#C00000" />
                </button>
              </div>
              <p className="text-xs mb-3" style={{ color: "#D4AF37" }}>{c.company}</p>
              <div className="text-xs space-y-1" style={{ color: "rgba(245,245,245,0.65)" }}>
                {c.email && <div>{c.email}</div>}
                {c.phone && <div>{c.phone}</div>}
                {c.address && <div className="opacity-75">{c.address}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
